import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { safe } from '../../documentos/commercialExcelUtils';
import { gradeHeightFileBase } from './buildGradeHeightParams';
import { drawGradeHeightSignaturePdf } from './gradeHeightSignature';

const MARGIN = 14;
const FONT_SIZE = 8;
const TITLE_FONT_SIZE = 11;
const GAP_BETWEEN_BLOCKS_MM = 4;

const HEADERS = [
  'Container',
  'Grade',
  'Pieces per bundle',
  'Bundles',
  'Thickness/Height',
  'Width',
  'Length',
  'Total',
];

const COLUMN_STYLES = {
  0: { cellWidth: 28 },
  1: { cellWidth: 14 },
  2: { cellWidth: 22 },
  3: { cellWidth: 16 },
  4: { cellWidth: 27 },
  5: { cellWidth: 18 },
  6: { cellWidth: 16 },
  7: { cellWidth: 18 },
};

function groupDetailBody(group) {
  return group.detailRows.map((d) => [
    d.container || '',
    d.grade,
    d.piecesPerBundle ?? '',
    d.bundles ?? '',
    d.thicknessHeight ?? '',
    d.width ?? '',
    d.length ?? '',
    d.total ?? '',
  ]);
}

function groupFootRow(group) {
  return [['', '', '', '', '', 'Total', '', group.totalM3 ?? '']];
}

function autoTableBlock(doc, y, group, withHeader) {
  autoTable(doc, {
    startY: y,
    margin: { left: MARGIN, right: MARGIN },
    head: withHeader ? [HEADERS] : [],
    body: groupDetailBody(group),
    foot: groupFootRow(group),
    showFoot: 'lastPage',
    theme: 'grid',
    styles: {
      fontSize: FONT_SIZE,
      cellPadding: 0.55,
      minCellHeight: 3.6,
      halign: 'center',
      valign: 'middle',
      lineColor: [0, 0, 0],
      lineWidth: 0.2,
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: 'bold',
    },
    columnStyles: COLUMN_STYLES,
    footStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: 'bold',
      lineColor: [0, 0, 0],
      lineWidth: 0.2,
    },
    didParseCell: (data) => {
      if (data.section !== 'foot') return;
      if (data.column.index !== 5 && data.column.index !== 7) {
        data.cell.text = [''];
      }
    },
  });
  return doc.lastAutoTable?.finalY ?? y;
}

export function gradeHeightPdfFileName(params) {
  return `${gradeHeightFileBase(params)}.pdf`;
}

export function buildGradeHeightPdfDoc(params) {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(FONT_SIZE);

  let y = MARGIN;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(TITLE_FONT_SIZE);
  doc.text('Invoice', MARGIN, y);
  doc.text(safe(params.numeroInvoice), MARGIN + 24, y);
  y += 5;
  doc.text('Height', MARGIN, y);
  y += 6;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(FONT_SIZE);

  const groups = params.groups || [];
  groups.forEach((group, gi) => {
    y = autoTableBlock(doc, y, group, gi === 0);
    if (gi < groups.length - 1) {
      y += GAP_BETWEEN_BLOCKS_MM;
    }
  });

  y += 7;
  drawGradeHeightSignaturePdf(doc, y);

  return doc;
}

export function generateGradeHeightPdf(params) {
  buildGradeHeightPdfDoc(params).save(gradeHeightPdfFileName(params));
}
